import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as S from "./StepTwo.styles";
import CreditCardMethod from "./methods/CreditCardMethod/CreditCardMethod";
import PaymentPix from "../../../../../../shared/components/PaymentPix";
import {
  setIsValidForm,
  setPaymentMethod,
} from "../../../../../../redux/slices/formSlice";
import creditCardIcon from "../../../../../../images/icons-figma/credit-card.svg";
import pixIcon from "../../../../../../images/icons-figma/pix.svg";
import cobrancaIcon from "../../../../../../images/icons-figma/cobranca.svg";

const paymentMethods = [
  {
    id: "credit-card",
    label: "Cartão de Crédito",
    icon: creditCardIcon,
  },
  { id: "pix", label: "PIX", icon: pixIcon },
];

const StepTwo = ({ formRef }) => {
  const dispatch = useDispatch();
  const selectedPaymentMethod = useSelector((state) => state.form.paymentMethod);

  return (
    <S.StepTwoContainer>
      <div>
        <div className="title-container">
          <img src={cobrancaIcon} alt="" />
          <p>Dados do pagamento</p>
        </div>

        <div className="payment-methods">
          {paymentMethods.map((method) => (
            <button
              type="button"
              key={method.id}
              className={`method-tab ${
                selectedPaymentMethod === method.id ? "active" : ""
              }`}
              onClick={() => {
                dispatch(setPaymentMethod(method.id));
                dispatch(setIsValidForm(false));
              }}
            >
              <img src={method.icon} alt="" />
              <span>{method.label}</span>
            </button>
          ))}
        </div>

        {selectedPaymentMethod === "credit-card" && (
          <CreditCardMethod formRef={formRef} />
        )}

        {selectedPaymentMethod === "pix" && <PaymentPix />}
      </div>
    </S.StepTwoContainer>
  );
};

export default StepTwo;
